import {
  Component,
  computed,
  effect,
  inject,
  signal,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { InactivityService } from "./utils/inactivity.service";
import { icons } from "./icons";
import { GlobalStore } from "./store/global.store";
import { Dialog, DialogRef } from "@angular/cdk/dialog";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { AuthStore } from "./pages/auth/store/auth.store";
import { MatProgressBar } from "@angular/material/progress-bar";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, MatProgressSpinner, MatProgressBar],
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent {
  @ViewChild("loadingModal")
  loadingModal!: TemplateRef<any>;

  dialogRef: DialogRef<TemplateRef<any>> | undefined;

  readonly globalStore = inject(GlobalStore);
  readonly authStore = inject(AuthStore);
  readonly dialog = inject(Dialog);

  iconRegistry = inject(MatIconRegistry);
  sanitizer = inject(DomSanitizer);

  private viewReady = signal(false);

  isLoading = computed(() => {
    const activeRequests = [...this.globalStore.activeRequests()];
    return !!activeRequests.length;
  });

  constructor(private inactivityService: InactivityService) {
    effect(() => {
      const isLoading = this.isLoading();
      if (!this.viewReady) return; // ← bail until view/ViewChild is ready
      if (isLoading) this.showLoadingSpinner();
      else this.closeLoadingSpinner();
    });

    this.inactivityService.startWatching();

    icons.forEach((icon) => {
      this.iconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(icon.iconUrl),
      );
    });
  }

  ngAfterViewInit() {
    this.viewReady.set(true);
    // re-check in case isLoading was already true while we were waiting
    if (this.isLoading()) this.showLoadingSpinner();
  }

  showLoadingSpinner() {
    if (!this.loadingModal) return; // defensive: never call dialog.open without a real TemplateRef
    if (!this.dialogRef || this.dialogRef.closed) {
      this.dialogRef = this.dialog.open(this.loadingModal, {
        backdropClass: "loading-overlay",
        autoFocus: "first-heading",
        disableClose: true,
      });
    }
  }

  closeLoadingSpinner() {
    this.dialogRef?.close();
  }
}
